<div class="diff-shell"><div #container class="diff-container"></div><span class="diff-state" *ngIf="loading()">비교 준비 중…</span><span class="diff-state error" *ngIf="error()" role="alert">{{ error() }}</span></div>
